import type { KnowledgeBaseWithIdentity } from '../../types/knowledge';

export function compareDatabasesByLastModifiedDesc(
  a: KnowledgeBaseWithIdentity,
  b: KnowledgeBaseWithIdentity,
): number {
  const aTime = a.lastModified ? Date.parse(a.lastModified) : 0;
  const bTime = b.lastModified ? Date.parse(b.lastModified) : 0;
  return bTime - aTime;
}
